export { default } from './SpeedMeter';

import './SpeedMeter.scss';
